import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

import { resumeSchema } from "./resume";

// Autosave sends the whole resume back, jobMatch included. The update never writes it, so it is
// accepted as-is rather than validated: an older stored shape must not make every save fail.
export const updateResumeSchema = resumeSchema.partial().extend({ jobMatch: z.any().optional() });

export class UpdateResumeDto extends createZodDto(updateResumeSchema) {}
